import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { RouteViewModel } from '../../../types/routeViewModel';
import type { CorrectionContext } from '../hooks/useCorrectionContext';
import { AddCargoSegmentWizard } from '../wizards/AddCargoSegmentWizard';

const { Text } = Typography;

type Props = {
  routeId: number;
  view: RouteViewModel;
  ctx: CorrectionContext;
  onSuccess: () => void;
};

export function CargoSegmentPanel({ routeId, view, ctx, onSuccess }: Props) {
  const [wizardOpen, setWizardOpen] = useState(false);

  if (!ctx.isOperationAllowed('ADD_CARGO_SEGMENT')) {
    return <Text type="secondary">Добавление сегмента груза недоступно.</Text>;
  }

  return (
    <div className="mutation-workspace__section">
      <div className="mutation-workspace__section-title">Сегмент груза</div>
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        Добавление погрузки выполняется через выбор источника груза и аллокацию — без адресной погрузки.
      </Text>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setWizardOpen(true)}>
        Добавить сегмент груза
      </Button>

      <AddCargoSegmentWizard
        routeId={routeId}
        view={view}
        ctx={ctx}
        open={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onSuccess={() => {
          setWizardOpen(false);
          onSuccess();
        }}
      />
    </div>
  );
}
